import { render } from 'preact';
import { ClerkProvider } from '@clerk/clerk-react';
import { App } from './App';
import './styles/global.css';

// Clerk publishable key from environment
const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!CLERK_PUBLISHABLE_KEY) {
	console.warn('VITE_CLERK_PUBLISHABLE_KEY not set. Auth will not work.');
}

render(
	<ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY || ''}>
		<App />
	</ClerkProvider>,
	document.getElementById('app')!
);
